import "@babel/polyfill";
import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import Reaptcha from 'reaptcha';
import Style from 'style-it';
import DominosStoreDropdown from "./dominos/store_dropdown";
import DominosFranchiseeDropdown from "./dominos/franchisee_dropdown";
import NotFoundPage from "./not_found_page"

export class LandingPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      stores: [],
      organization: {
        form_configuration: {
          background_image: '',
          button_color: '',
          field_label_color: '',
          logo: ''
        },
        custom_fields: []
      },
      organization_id: gon.organization_id,
      request_running: false,
      show_success: false,
      show_pending_registration: false,
      fields_errors: {
        first_name: '',
        last_name: '',
        email: ''
      },
      recaptcha: false,
      recaptcha_error: false,
      recaptcha_response: null,
    }

    this.loadStores = this.loadStores.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFormErrors = this.handleFormErrors.bind(this);
    this.getFieldClass = this.getFieldClass.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  componentDidMount() {
    const endpoint = this.props.preview
      ? `/organizations/${gon.organization_id}/api/v1/preview/?organization_id=${gon.organization_id}`
      : `/organizations/${gon.organization_id}/api/v1/form_content/?organization=${gon.organization_id}`;

    axios.get(endpoint).then(res => {
      const organization = res.data.data;
      this.setState({ organization });
    });
  }

  handleChange = (index) => (event) => {
    const value = event.target.value;

    const custom_fields = this.state.organization.custom_fields.map((field, fieldIndex) => {
      if (index !== fieldIndex) return field;
      return { ...field, value: value };
    });

    this.setState({
      organization: {
        ...this.state.organization,
        custom_fields: custom_fields
      }
    });
  }

  loadStores(stores) {
    this.setState({ stores: stores });
  }

  validateForm() {
    var all_valid = true
    const fields_errors = {first_name: '', last_name: '', email: ''}
    this.setState({ fields_errors, recaptcha_error: false });
    const custom_fields = this.state.organization.custom_fields.map((field) => {
      if (!field.value && field.visible) {
        field.error = true
        all_valid = false
      } else {
        field.error = false
      }
    });
    return all_valid
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.props.preview) return;

    if (this.validateForm()) {
      this.setState({ request_running: true })
      const data = {
        fields: this.state.organization.custom_fields,
        organization: this.state.organization_id,
        "g-recaptcha-response": this.state.recaptcha_response,
      }
      axios.post(
        `/organizations/${gon.organization_id}/api/v1/sign_up`, data
      ).then(res => {
        if(res.data.workflow_state == "pending") {
          this.setState({ request_running: false, show_pending_registration: true })
        } else {
          this.setState({ request_running: false, show_success: true })
        }
      }).catch(error => {
        if (error.response.status === 500) {
          alert('An error occurred during request. Please try again.')
        } else {
          this.handleFormErrors(error.response.data.errors)
          this.setState({ request_running: false })
        }
      });
    }
  }

  handleFormErrors(errors) {
    const fields_errors = {first_name: '', last_name: '', email: ''}
    errors.first_name && (fields_errors.first_name = errors.first_name[0]);
    errors.last_name && (fields_errors.last_name = errors.last_name[0]);
    errors.email && (fields_errors.email = errors.email[0]);

    if(errors.recaptcha && this.recaptcha) {
      this.recaptcha.reset();
    }

    this.setState({ fields_errors, recaptcha_error: !!(errors.recaptcha) });
  }

  getFieldError(field_name) {
    switch(field_name) {
      case "First Name":
          return this.state.fields_errors.first_name
          break;
      case "Last Name":
          return this.state.fields_errors.last_name
          break;
      case "Email":
          return this.state.fields_errors.email
          break;
    }
  }

  getFieldClass(field) {
    if (field.name === "First Name" && (this.state.fields_errors.first_name || field.error)) {
      return "form-group invalid-field custom-input-label mb-4"
    } else if (field.name === "Last Name" && (this.state.fields_errors.last_name || field.error)) {
      return "form-group invalid-field custom-input-label mb-4"
    } else if (field.name === "Email" && (this.state.fields_errors.email || field.error)) {
      return "form-group invalid-field custom-input-label mb-4"
    } else {
      return "form-group custom-input-label mb-5"
    }
  }

  captchaReturn = (response) => {
    this.setState({
      recaptcha: true,
      recaptcha_response: response,
    });
  }

  captchaExpired = (response) => {
    this.setState({ recaptcha: false });
  }

  addFocusStyle(elementId) {
    const inputEl = document.getElementById(elementId);
    const labelEl = document.getElementById(`${elementId}-label`);
    inputEl.style.borderBottomColor = this.state.organization.form_configuration.button_color;
    labelEl.style.color = this.state.organization.form_configuration.button_color;
  }

  addInitialStyle(elementId) {
    const inputEl = document.getElementById(elementId);
    const labelEl = document.getElementById(`${elementId}-label`);
    inputEl.style.borderBottomColor = this.state.organization.form_configuration.field_label_color;
    labelEl.style.color = this.state.organization.form_configuration.field_label_color;
  }

  renderPendingRegistrationMessage() {
    if(this.state.show_pending_registration) {
      return (
        <p className="dyn-field-label-color reg-message">
          Your registration is pending. An admin is reviewing your info and you will receive an email once your account has been registered.
        </p>
      );
    } else {
      return null;
    }
  }

  renderSuccessMessage() {
    if(this.state.show_success) {
      return (
        <p className="dyn-field-label-color reg-message">
          We have sent a verification email to {this.state.organization.custom_fields.filter((field) => field.name == "Email")[0].value}. Follow the provided link to finalize your account.
          If you do not receive this email within a few minutes, check your Spam or Junk email folders.
        </p>
      );
    } else {
      return null;
    }
  }

  renderForm() {
    if(!this.state.show_pending_registration && !this.state.show_success) {
      return (
        <div><p className="header-new-user dyn-field-label-color">New User</p>
          <form onSubmit={this.onSubmit}>
            {this.state.organization.custom_fields.map((custom_field, index) => {
              switch (custom_field.field_type) {
                case 'Text Field':
                  return <div className={custom_field.error ? "form-group invalid-field custom-input-label mb-4" : "form-group custom-input-label mb-5"}
                    key={custom_field.id} style={{ display: custom_field.visible ? 'block' : 'none' }}>
                    <input name={custom_field.field_id} id={custom_field.field_id} type="text" className="form-control dyn-field-border-color dyn-field-label-color" required={custom_field.required}
                      data-empty={!(custom_field.value !== '')}
                      value={custom_field.value}
                      onFocus={() => this.addFocusStyle(custom_field.field_id)}
                      onBlur={() => this.addInitialStyle(custom_field.field_id)}
                      onChange={this.handleChange(index)} />
                    <label htmlFor={custom_field.field_id} id={`${custom_field.field_id}-label`}
                      className={(custom_field.name.length > 50) ? "mb-0 wrapped-label-two-lines dyn-field-label-color" : "mb-0 wrapped-label-one-line dyn-field-label-color"}>{custom_field.required && '*'} {custom_field.name}</label>
                    <span className="error-msg mb-0 dyn-field-label-color">{this.getFieldError(custom_field.name)}</span>
                    <span className="error-msg mb-0 dyn-field-label-color">{custom_field.error === true ? "can't be blank" : custom_field.error && custom_field.error}</span>
                    <span className="float-right dyn-field-label-color">{custom_field.tooltip}</span>
                  </div>
                case 'Franchisee Dropdown':
                  return <DominosFranchiseeDropdown
                            loadStores={this.loadStores}
                            customField={custom_field}
                            onFocus={() => this.addFocusStyle(custom_field.field_id)}
                            onBlur={() => this.addInitialStyle(custom_field.field_id)}
                            onChange={this.handleChange(index)} />
                case 'Store Dropdown':
                  return <DominosStoreDropdown
                           stores={this.state.stores}
                           customField={custom_field}
                           onFocus={() => this.addFocusStyle(custom_field.field_id)}
                           onBlur={() => this.addInitialStyle(custom_field.field_id)}
                           onChange={this.handleChange(index)} />
                case 'Dropdown':
                  return <div className={custom_field.error ? "form-group invalid-field mb-5" : "form-group mb-5"} key={custom_field.id} style={{ display: custom_field.visible ? 'block' : 'none' }}>
                             <label htmlFor={custom_field.field_id} id={`${custom_field.field_id}-label`}
                                    className="mb-0 wrapped-label-one-line dyn-field-label-color">{custom_field.required && '*'} {custom_field.name}</label>

                             <div className="select-dropdown">
                                 <select name={custom_field.field_id}
                                         id={custom_field.field_id}
                                         className="form-control pl-0 dyn-field-border-color dyn-field-label-color"
                                         required={custom_field.required}
                                         value={custom_field.value}
                                         onFocus={() => this.addFocusStyle(custom_field.field_id)}
                                         onBlur={() => this.addInitialStyle(custom_field.field_id)}
                                         onChange={this.handleChange(index)}>
                                     <option value=""></option>

                                     {
                                         custom_field.custom_field_options.map(option => {
                                             return <option value={option.value} key={option.id}>{option.value}</option>
                                         })
                                     }
                                 </select>

                                 <i className="fa fa-angle-down dyn-field-label-color"></i>
                             </div>

                             <span className="float-right dyn-field-label-color">{custom_field.tooltip}</span>
                             <span className="error-msg mb-0 dyn-field-label-color">{custom_field.error && "Please choose an option"}</span>
                         </div>
                case 'Radio Button':
                  return <div className={custom_field.error ? "form-group invalid-field clearfix button-group" : "form-group clearfix button-group"} key={custom_field.id} style={{ display: custom_field.visible ? 'block' : 'none' }}>
                    <label htmlFor={custom_field.field_id}
                      className={(custom_field.name.length > 53) ? "mb-0 wrapped-label-two-lines dyn-field-label-color" : "mb-0 wrapped-label-one-line dyn-field-label-color"}>{custom_field.name}</label>
                    <div className="select-dropdown">
                      <div>
                        {custom_field.custom_field_options.map(option => {
                          return <div key={option.id}>
                            <label className="radio-label formradio dyn-field-label-color"> {option.value}
                              <input type="radio" name={custom_field.field_id} value={option.value} onChange={this.handleChange(index)} />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                        })
                        }
                      </div>
                    </div>
                    <span className="float-right dyn-field-label-color">{custom_field.tooltip}</span>
                    <span className="error-msg mb-0 dyn-field-label-color">{custom_field.error && "Please choose an option"}</span>
                  </div>
              }
            }
            )}
            {!this.props.preview && gon.recaptcha_required &&
              <div className="form-group invalid-field mb-5">
                <Reaptcha
                  ref={e => (this.recaptcha = e)}
                  sitekey={gon.recaptcha_site_key}
                  onVerify={this.captchaReturn}
                  onExpire={this.captchaExpired}
                />
                <span className="error-msg mb-0 dyn-field-label-color">{this.state.recaptcha_error && "Verify Captcha"}</span>
              </div>
            }
            <input className="btn dyn-btn-bg-color" type="submit" value="CREATE ACCOUNT" disabled={this.state.request_running ? true : null} />
            <div>
              <a
                href={this.props.preview ? '#' : (this.state.organization.vanity_url || this.state.organization.signup_account) + '/login'}
                onClick={this.props.preview ? (event) => event.preventDefault() : undefined}
                className="dyn-btn-color"
              >Already have an account?</a>
            </div>
          </form>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    if (!gon.organization_id) {
      return <NotFoundPage/>
    }

    const labelColor = this.state.organization.form_configuration.field_label_color;
    const backgroundColor = this.state.organization.form_configuration.background_color;
    const buttonColor = this.state.organization.form_configuration.button_color;

    return (
      <div className="landing-page registration-page ">
        <Style>
          {
            `
              .formradio .checkmark:after {
                background: ${labelColor};
              }
              .formradio .checkmark {
                border-color: ${labelColor} !important;
              }
              .dyn-background-color {
                background-color: ${backgroundColor} !important;
              }
              .dyn-field-label-color {
                color: ${labelColor} !important;
              }
              .reg-message {
                text-transform: initial !important;
              }
              .wrapped-label-one-line {
                top: 0px !important;
              }
              .wrapped-label-two-lines {
                top: -12px !important;
              }
              .dyn-btn-bg-color {
                background-color: ${buttonColor} !important;
              }
              .dyn-btn-color {
                color: ${buttonColor};
              }
              .dyn-field-border-color {
                border-bottom: 1px solid ${labelColor} !important;
              }
              .dyn-background-image {
                background: transparent;
                background-image: url(${this.state.organization.form_configuration.background_image});
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
              }
            `
          }
        </Style>
        <div className="preview-wrapper registration-form full-height dyn-background-color">
          <div className="row dyn-background-image">
            <div className="col-sm-12 col-md-8 col-lg-4 padding-lg dyn-background-color form-column col-centered">
              <div className="container">
                { this.state.organization.form_configuration.logo &&
                  <img src={this.state.organization.form_configuration.logo} alt={this.state.organization.form_configuration.logo}/>
                }
                <h1 className="padding-title dyn-field-label-color">Registration</h1>
                {this.renderSuccessMessage()}
                {this.renderPendingRegistrationMessage()}
                {this.renderForm()}
            </div>
          </div>
        </div>
      </div>
    </div>
    )
  }
}

const landingPageElement = document.querySelector('.landing-page');

if (landingPageElement) {
  createRoot(landingPageElement).render(<LandingPage />);
}
